import { render, staticRenderFns } from "./MobileNavButton.vue?vue&type=template&id=dfb35b28&scoped=true&"
import script from "./MobileNavButton.vue?vue&type=script&lang=js&"
export * from "./MobileNavButton.vue?vue&type=script&lang=js&"
import style0 from "./MobileNavButton.vue?vue&type=style&index=0&id=dfb35b28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfb35b28",
  null
  
)

export default component.exports